import { render } from "./About.vue?vue&type=template&id=beda9a88"
const script = {}
script.render = render

export default script